React = require 'react'
{ FormatCurrency } = require 'react-globalize'

module.exports = ({ cents, locale: { currency }}) ->
  <FormatCurrency currency={currency}>{ cents / 100.0 }</FormatCurrency>